import React, { memo, useContext, useMemo } from 'react';
import { st, classes } from '../../Widget.st.css';
import AccordionsTwoColumns from './AccordionsTwoColumns';
import AccordionsOneColumn from './AccordionOneColumn';
import { Structure } from '../../../../../enums';
import { useSettings } from '@wix/tpa-settings/react';
import { ISettingsContextValue } from '@wix/tpa-settings';
import settingsParams from '../../../settingsParams';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import { AccordionCSS } from '../Interfaces';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { DATA_HOOKS } from '../../../../../constants/dataHooksElements';
import { AppContext } from '../../SettingsProvider/SettingsProvider';
import { useLayoutType } from '../../../../../hooks/useLayoutType';
import { useQuestionHtmlTag } from '../../../../../hooks/useQuestionHtmlTag';

const AccordionWrapperComponent = ({
  filteredQuestions,
}: {
  filteredQuestions: QuestionEntry[];
}) => {
  const { isEditor3, firstQuestionId, baseURL } = useContext(AppContext);
  const { isMobile } = useEnvironment();
  const settings: ISettingsContextValue = useSettings();
  const structureColumn: Structure = settings.get(settingsParams.structure);
  const twoColumnStructure: boolean =
    structureColumn === Structure.TWO_COLUMNS && !isMobile;
  const {
    spacing: { gap, betweencols },
    itemAppearance,
    openQuestionIcon,
  } = useLayoutType(isEditor3);

  const noAnimation = !settings.get(settingsParams.enableScrollAnimation);
  const openFirstAnswer = settings.get(settingsParams.openFirstAnswer);
  const openOneAnswer = settings.get(settingsParams.openOneAnswer);
  const layout_type = settings.get(settingsParams.layout);
  const questionHtmlTag = useQuestionHtmlTag();
  const questionFontParam = useMemo(
    () => ({ htmlTag: questionHtmlTag }),
    [questionHtmlTag],
  );
  return (
    <div
      style={
        {
          '--item-gap': `${gap}px`,
          '--column-gap': `${betweencols}px`,
        } as AccordionCSS
      }
      className={st(classes.Body, { isTwoColumn: twoColumnStructure })}
      data-hook={DATA_HOOKS.WIDGET_ACCORDION_WRAPPER}
    >
      {twoColumnStructure ? (
        <AccordionsTwoColumns
          filteredQuestions={filteredQuestions}
          firstQuestionId={firstQuestionId}
          baseURL={baseURL}
          noAnimation={noAnimation}
          openOneAnswer={openOneAnswer}
          suppressInitialOpenAnimation={openFirstAnswer}
          layout_type={layout_type}
          itemAppearance={itemAppearance}
          openQuestionIcon={openQuestionIcon}
          questionFontParam={questionFontParam}
        />
      ) : (
        <AccordionsOneColumn
          filteredQuestions={filteredQuestions}
          firstQuestionId={firstQuestionId}
          baseURL={baseURL}
          noAnimation={noAnimation}
          openOneAnswer={openOneAnswer}
          suppressInitialOpenAnimation={openFirstAnswer}
          layout_type={layout_type}
          itemAppearance={itemAppearance}
          openQuestionIcon={openQuestionIcon}
          questionFontParam={questionFontParam}
        />
      )}
    </div>
  );
};

const AccordionWrapper = memo(AccordionWrapperComponent);
AccordionWrapper.displayName = 'AccordionWrapper';

export default AccordionWrapper;
